import React from 'react';
import ReactDOM from 'react-dom';
import Facility from './sports.js';

Storage.prototype.setObject = function(key, value) {
  this.setItem(key, JSON.stringify(value));
}

Storage.prototype.getObject = function(key) {
  var value = this.getItem(key);
  return value && JSON.parse(value);
}

document.addEventListener("DOMContentLoaded", function() {
  if (document.getElementById('sports')) {
    ReactDOM.render(
      <Facility></Facility>,
      document.getElementById('sports')
    );
  }
})
